const createFieldIds = (id) => {
  return {
    checkbox: `item-checkbox-${id}`,
    reason: `item-reason-${id}`,
    quantity: `item-quantity-${id}`
  };
};
export {
  createFieldIds
};
//# sourceMappingURL=create-field-ids.js.map
